import React from 'react';
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import NotAuthorisedStyle from "./NotAuthorisedStyle";

function NotAuthorised({ ...props }) {
    const { classes } = props;
    return (
        <div className={classes.notAuthorisedContianer}>
            <div className={classes.notAuthorisedContent}>
                <h1>401 - You are not authorised to view this page.</h1>
            </div>
        </div>
    );
};

NotAuthorised.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(NotAuthorisedStyle)(NotAuthorised);